import { render, staticRenderFns } from "./tareasHandler.vue?vue&type=template&id=8f950de0&"
import script from "./tareasHandler.vue?vue&type=script&lang=ts&"
export * from "./tareasHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports